<template>
  <div>
    <el-dialog
      title="Create campaign"
      :visible="dialog_campaign"
      width="728px"
      :modal="true"
      @close="setDialogCampaign(false)"
    >
      <el-form>
        <el-form-item label="Campaign Name" :label-width="formLabelWidth">
          <el-input autocomplete="off" v-model="campaign.name"></el-input>
        </el-form-item>
        <el-form-item label="Campaign Top Up" :label-width="formLabelWidth">
          <el-radio-group v-model="groupVal" @change="groupChange">
            <el-radio-button
              class="campaign-radio"
              label="100$"
            ></el-radio-button>
            <el-radio-button
              class="campaign-radio"
              label="500$"
            ></el-radio-button>
            <el-radio-button
              class="campaign-radio"
              label="2000$"
            ></el-radio-button>
          </el-radio-group>
          <el-input
            class="custom-input"
            placeholder="Custom $"
            v-model="customVal"
            @change="customChange"
          ></el-input>
        </el-form-item>
        <el-form-item label="Insert Track" :label-width="formLabelWidth">
          <el-select
            v-model="campaign.track_id"
            clearable
            filterable
            class="mr10"
          >
            <el-option
              v-for="a in tracks"
              :key="a.id"
              :value="a.id"
              :label="a.title"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="Campaign date range" :label-width="formLabelWidth">
          <el-date-picker
            type="daterange"
            unlink-panels
            range-separator="-"
            start-placeholder="Start date"
            end-placeholder="End date"
            :picker-options="dateRangeOptions"
            format="d MMMM yyyy"
            value-format="yyyy-MM-dd"
            v-model="datePicker"
          ></el-date-picker>
        </el-form-item>
        <div class="flex-end mt60">
          <!--           <el-form-item label-width="50px">
            <el-checkbox class="regular">Confirm Amount</el-checkbox>
          </el-form-item> -->
          <el-form-item label-width="40px">
            <el-button type="primary btn-main" @click="saveCampaign()"
              >Save</el-button
            >
          </el-form-item>
        </div>
      </el-form>
      <span slot="footer" class="dialog-footer"> </span>
    </el-dialog>

    <el-dialog
      class="confirm-bar"
      title="Campaign"
      :visible.sync="confirmBar"
      width="30%"
    >
      <div>
        <span
          >Your campaign {{ campaign.name }}<br />
          is created!</span
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapState, mapActions, mapMutations } from 'vuex'

export default {
  data() {
    return {
      datePicker: [],
      confirmBar: false,
      formLabelWidth: '200px',
      groupVal: null,
      customVal: null
    }
  },

  computed: {
    ...mapState('artistVidCents', ['campaign', 'dialog_campaign', 'tracks'])
  },

  methods: {
    ...mapActions('artistVidCents', ['createCampaign', 'getTracks']),
    ...mapMutations('artistVidCents', ['setDialogCampaign', 'setCampaign']),
    saveCampaign() {
      this.$confirm('Confirm creating campaign?', 'Warning', {
        confirmButtonText: 'OK',
        cancelButtonText: 'Cancel',
        type: 'warning'
      })
        .then(() => {
          this.setDialogCampaign(false)
          if (this.groupVal !== null) {
            if (this.groupVal.includes('$')) {
              this.campaign.amount = this.groupVal.substring(
                0,
                this.groupVal.length - 1
              )
            } else {
              this.campaign.amount = this.groupVal
            }
          } else {
            this.campaign.amount = this.customVal
          }
          this.campaign.start = this.datePicker[0]
          this.campaign.end = this.datePicker[1]
          this.createCampaign().then(r => {
            if (r == 1) {
              this.confirmBar = true
            }
          })
        })
        .catch(() => {})
    },
    customChange() {
      if (this.groupVal !== null) {
        this.groupVal = null
      }
    },
    groupChange() {
      if (this.customVal !== null) {
        this.customVal = null
      }
    }
  },
  created() {
    this.getTracks()
  }
}
</script>

<style scoped>
.el-radio-button__orig-radio:checked + .el-radio-button__inner {
  color: #ffffff;
  background-color: #605677;
  border-color: #605677;
  -webkit-box-shadow: -1px 0 0 0 #605677;
  box-shadow: -1px 0 0 0 #605677;
}
</style>
